import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "uc-task-statuses" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Добавить статус", -1)

import { TirPmGlobalStatus } from "@/components/task-parameters-form/components";
import {
  PopoverPositionEnum,
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmOptionList,
  TirPmOptionListGroupSeparator,
  TirPmOptionListItemElement,
  TirPmPopover,
  TirPmStatus,
  TirPmStatusBgEnum,
  TirPmStatusTextEnum,
} from "tir-components";
import { PlusIcon } from "tir-style-system/icons/outline";
// Импорты из Vue 3 Composition API
import { ref, computed, onMounted, watch } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'task-status-dropdown-new',
  props: {
  isOpened: { type: Boolean, value: false },
  selected: { type: Object, value: null },
},
  emits: ["isOpened"],
  setup(__props, { emit: emits }) {

const props = __props;

const values = ref([]);
const selectedData = ref();

function update(value: any) {
  console.log("value update", value);
}
// Определение пропсов компонента

function checkOpenOptions(value: any) {
  console.log("value", value);
}
// // Определение эмиттеров событий компонента


// // Отслеживание изменений пропса isCompact
// watch(
//   () => props.isCompact,
//   () => {
//     if (props.isCompact) {
//       console.log("Свойство isCompact поменялось на true");
//     }
//   }
// );

// const latitude = computed({
// get() {
// return lat.value || props.Latitude || 0;
// },
// set(newValue: number) {
// console.log(`newValue`, newValue);
// lat.value = newValue;
// },
// });
// // Блок переменных
// const count = ref(0); // Переменная для подсчета
// const message = ref(""); // Переменная для сообщения

// // Жизненный цикл компонента (при монтировании)
// onMounted(() => {
//   console.log("Компонент монтирован.");
// });

// // Вычисляемое свойство (двойное значение счетчика)
// const doubledCount = computed(() => count.value * 2);

// // Функция для увеличения счетчика
// function increment() {
//   count.value++;
// }

// // Функция для изменения сообщения и эмиттинга события обновления
// function changeMessage() {
//   message.value = "Новое сообщение!";
//   emits("update:message", message.value);
// }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TirPmPopover), {
      width: "16.25rem",
      style: {"width":"100%"},
      position: _unref(PopoverPositionEnum).Bottom
    }, {
      default: _withCtx(() => [
        (!__props.selected)
          ? (_openBlock(), _createBlock(_unref(TirPmButton), {
              key: 0,
              variant: _unref(TirPmButtonVariantEnum).SecondaryState,
              size: _unref(TirPmButtonSizeEnum).Small,
              class: "task-parameters-table_item_name_button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('isOpened', __props.isOpened)))
            }, {
              leftSlot: _withCtx(() => [
                _createVNode(_unref(PlusIcon), { style: {"width":"1rem","height":"1rem"} })
              ]),
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["variant", "size"]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "selected", {}, () => [
          (__props.selected)
            ? (_openBlock(), _createBlock(_unref(TirPmGlobalStatus), {
                key: 0,
                value: __props.selected
              }, null, 8, ["value"]))
            : _createCommentVNode("", true)
        ])
      ]),
      content: _withCtx(() => [
        _renderSlot(_ctx.$slots, "content")
      ]),
      _: 3
    }, 8, ["position"])
  ]))
}
}

})